import React, { useEffect, useState, useRef } from 'react';
import ePub from 'epubjs';
import { ChevronLeftIcon, ChevronRightIcon, CloudDownloadIcon, XCircleIcon } from '@heroicons/react/solid';
import styles from './bookepub.module.css';
import Loader from './Loader';
var TOOLBAR_HEIGHT = 48;
export var BookEpub = function (_a) {
    var type = _a.type, url = _a.url, title = _a.title, loc = _a.loc, closeBook = _a.closeBook, downloadBook = _a.downloadBook;
    var _b = useState(), rendition = _b[0], setRendition = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var refDisplay = useRef();
    var currentSectionIndex = loc ? loc : undefined;
    var previousPage = function () {
        rendition === null || rendition === void 0 ? void 0 : rendition.prev();
    };
    var nextPage = function () {
        rendition === null || rendition === void 0 ? void 0 : rendition.next();
    };
    var keyListener = function (e) {
        if ((e.keyCode || e.which) == 37)
            previousPage();
        if ((e.keyCode || e.which) == 39)
            nextPage();
        if ((e.keyCode || e.which) == 88)
            closeBook();
    };
    var selectedRange = function (book) {
        return function (cfiRange) {
            // The API typescript seems to have the wrong types
            book.getRange(cfiRange).then(function (r) {
                console.log(r.toString());
            });
        };
    };
    useEffect(function () {
        refDisplay.current.textContent = '';
        var book = ePub(url, {
            openAs: type,
        });
        var rendLocal = book.renderTo(refDisplay.current.id, {
            manager: 'continuous',
            flow: 'paginated',
            width: '100%',
            height: '100%',
        });
        var displayed = rendLocal.display(currentSectionIndex);
        displayed.then(function () {
            setRendition(rendLocal);
        });
        book.ready.then(function () {
            rendLocal.on('keyup', keyListener);
            rendLocal.on('selected', selectedRange(book));
            setLoading(false);
        });
        document.addEventListener('keyup', keyListener, false);
        return function () {
            document.removeEventListener('keyup', keyListener);
        };
    }, [url]);
    return (React.createElement("div", { className: "fixed inset-0 bg-gray-200 flex flex-col" },
        React.createElement("div", { className: "flex items-center justify-between gap-3 px-3 bg-white border-b border-gray-200 shadow-sm flex-shrink-0 z-50", style: { height: TOOLBAR_HEIGHT } },
            React.createElement("div", { className: "flex items-center gap-2 min-w-0" },
                React.createElement("button", { type: "button", onClick: closeBook, className: "p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100", title: "Back to library" },
                    React.createElement(XCircleIcon, { className: "h-5 w-5", "aria-hidden": "true" })),
                title && React.createElement("span", { className: "text-sm font-medium text-gray-700 truncate" }, title)),
            !loading && (React.createElement("div", { className: "flex items-center gap-1 flex-shrink-0" },
                React.createElement("button", { type: "button", onClick: previousPage, className: "p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100", title: "Previous page" },
                    React.createElement(ChevronLeftIcon, { className: "h-4 w-4", "aria-hidden": "true" })),
                React.createElement("button", { type: "button", onClick: nextPage, className: "p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100", title: "Next page" },
                    React.createElement(ChevronRightIcon, { className: "h-4 w-4", "aria-hidden": "true" })))),
            React.createElement("button", { type: "button", onClick: function () { return downloadBook(url); }, className: "p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 flex-shrink-0", title: "Download" },
                React.createElement(CloudDownloadIcon, { className: "h-5 w-5", "aria-hidden": "true" }))),
        React.createElement("main", { className: "flex-1 relative overflow-auto" },
            React.createElement("div", { className: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 h-full" },
                loading && (React.createElement("div", { className: "flex items-center justify-center w-full h-full" },
                    React.createElement(Loader, null))),
                React.createElement("div", { id: "bookarea", className: "rounded-sm bg-white shadow-md h-full " + styles.bookDisplay, ref: refDisplay })),
            !loading && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "fixed left-0 w-1/6 bg-transparent cursor-pointer", style: { top: TOOLBAR_HEIGHT, bottom: 0 }, onClick: previousPage }),
                React.createElement("div", { className: "fixed right-0 w-1/6 bg-transparent cursor-pointer", style: { top: TOOLBAR_HEIGHT, bottom: 0 }, onClick: nextPage }))))));
};
export default BookEpub;
